import { PaneInfoPrimitive } from "./pane-info";

export class MainInfoPrimitive extends PaneInfoPrimitive {
    onAttach() {
        const param = this._attachedParams;
        if (!param) return;

        const series = this.series();
        if (this.chartType === "line") {
            const buyData = series?.get("buySeries")?.data?.() || [];
            const sellData = series?.get("sellSeries")?.data?.() || [];
            const historicalData = series?.get("historicalSeries")?.data?.() || [];
            let buy, sell, historical;
            const visibleRange = this.chart()?.timeScale()?.getVisibleRange();
            const buyInRange = buyData.filter((d) => d.time >= visibleRange.from && d.time <= visibleRange.to);
            const sellInRange = sellData.filter((d) => d.time >= visibleRange.from && d.time <= visibleRange.to);
            const historicalInRange = historicalData.filter((d) => d.time >= visibleRange.from && d.time <= visibleRange.to);
            buy = buyInRange.at(-1);
            sell = sellInRange.at(-1);
            historical = historicalInRange.at(-1);

            this.update(historical, buy, sell);
        }
    }
    onMouseMove = (param) => {
        const series = this.series();
        if (this.chartType === "line") {
            let buy, sell, historical;
            if (param) {
                historical = param.seriesData.get(series?.get("historicalSeries"));
                buy = param.seriesData.get(series?.get("buySeries"));
                sell = param.seriesData.get(series?.get("sellSeries"));
            }

            if (buy || sell || historical) {
                this.update(historical, buy, sell);
            }
        }
    };

    update(historical, buy, sell) {
        const indicators = this.indicators;
        this.updateContent([]);
        let mainContent = [];
        if (this.itemIcon) mainContent.push({ icon: this.itemIcon });
        if (this.itemName) mainContent.push({ text: this.itemName + " / ", color: "#fff" });
        if (this.currencyIcon) mainContent.push({ icon: this.currencyIcon });
        mainContent.push({ text: ` • ${this.activeTab} • `, color: "#fff" });
        if (historical && historical.value) {
            mainContent.push({ text: "H ", color: indicators.get("historicalPrice").colorOptions.color });
            mainContent.push({ text: String(historical.value) + " ", color: indicators.get("historicalPrice").colorOptions.color });
            const histChange = historical.customValues.previousValuePercentChange;
            const prefix = histChange >= 0 ? "+" : "";
            const histChangeText = histChange.toFixed(2) + "%";
            const color = histChange >= 0 ? indicators.get("buyPrice").colorOptions.color : indicators.get("sellPrice").colorOptions.color;
            const text = `(${prefix}${histChangeText}) `;
            mainContent.push({
                text,
                color,
            });
        }
        if (buy && buy.value) {
            mainContent.push({ text: "B ", color: "#aaa" });
            mainContent.push({ text: String(buy.value) + " ", color: indicators.get("buyPrice").colorOptions.color });
            const buyChange = buy.customValues.previousValuePercentChange;
            const prefix = buyChange >= 0 ? "+" : "";
            const buyChangeText = buyChange.toFixed(2) + "%";
            const color = buyChange >= 0 ? indicators.get("buyPrice").colorOptions.color : indicators.get("sellPrice").colorOptions.color;
            const text = `(${prefix}${buyChangeText}) `;
            mainContent.push({
                text,
                color,
            });
        }
        if (sell && sell.value) {
            mainContent.push({ text: "S ", color: "#aaa" });
            mainContent.push({ text: String(sell.value) + " ", color: indicators.get("sellPrice").colorOptions.color });
            const sellChange = sell.customValues.previousValuePercentChange;
            const prefix = sellChange >= 0 ? "+" : "";
            const sellChangeText = sellChange.toFixed(2) + "%";
            const color = sellChange >= 0 ? indicators.get("buyPrice").colorOptions.color : indicators.get("sellPrice").colorOptions.color;
            const text = `(${prefix}${sellChangeText})`;
            mainContent.push({
                text,
                color,
            });
        }

        this.updateContent(mainContent);
    }
}
